import "../../assets/css/wizardMenu/wizardMenu.css"

import { WIZARD_BUTTONS } from "./utils.js"
import { SECTIONS } from "../../utils/globalUtils.js"
import { useAuth } from "../../context/auth-context.jsx"

export default function WizardMenu(props) {
    const {
        state
    } = props

    const { updateUser } = useAuth()

    const handleButtonClick = (label) => {
        if (label === state.activeSection) return

        if (label === WIZARD_BUTTONS.find(option => option.name === "login")?.name) return updateUser(null)
    }

    return (
        <div className="wizardContainer">
            {WIZARD_BUTTONS.map(option => {
                const buttonClass = `wizard-button ${state.activeSection === option.name ? "selected" : ""}`
                const buttonDisabled = buttonClass && (option.name === SECTIONS.auth || option.name === SECTIONS.report) && option.name !== state.activeSection

                return (
                    <button
                        key={option.name}
                        className={buttonClass}
                        onClick={() => handleButtonClick(option.name)}
                        disabled={buttonDisabled}
                    >
                        {option.title}
                    </button>
                )
            })}
        </div>
    )
}